/**
 * @module components\subroute\Recharge
 */
import Vue from "vue";
import Component from "vue-class-component";
import RechargeDetails from "@/components/RechargeDetails/RechargeDetails.vue";

@Component({
  components: {
    RechargeDetails
  }
})
export default class Recharge extends Vue {}
